<template>
  <div>
    <NotFoundData v-if="isEmptyData" />
    <div :style="{ visibility: isEmptyData ? 'collapse' : 'visible' }">
      <div class="contenedor-grafica"></div>
      <hr>
      <p class="text-dark w-100">
        Personaliza los filtros para cada gráfica, seleccionando las etiquetas de forma individual.
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as echarts from "echarts";
import servicios from "../../../servicios/service.js";
import NotFoundData from "@/Aplicaciones/Masters/Areas/Prospecto/components/Graficas/NotFoundData.vue"

const concentradoFinal =
  "/api/Dashboard/Dashboard/ObtenerConcentradoFinaldeOperaciones";
const labelFormatMontoOperaciones = {
  color: "#000000",
  fontSize: 14,
  fontWeight: "bold",
  position: "top",
  show: true,
  formatter: function (valor) {
    return servicios.DarFormatoMoneda(valor.value);
  }
};
export default {
  components: {
    NotFoundData
  },
  name: "GraficaReporteConcentradoFinal",
  props: [
    "masterId",
    "embajadorId",
    "sucursalId",
    "gerenciaId",
    "fechaInicio",
    "fechaFinal",
    "mostrarTodo"
  ],
  data() {
    return {
      dataConcentrado: []
    }
  },
  mounted() {
    this.reporteConcentradoFinalGrafica(
      this.masterId,
      this.embajadorId,
      this.sucursalId,
      this.gerenciaId,
      this.fechaInicio,
      this.fechaFinal,
      this.mostrarTodo
    );
  },
  watch: {
    mostrarTodo() {
      this.reporteConcentradoFinalGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
    },
    fechaInicio() {
      this.reporteConcentradoFinalGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
    },
    fechaFinal() {
      this.reporteConcentradoFinalGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
    },
    gerenciaId() {
      this.reporteConcentradoFinalGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
    },
    sucursalId() {
      this.reporteConcentradoFinalGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
    },
    embajadorId() {
      this.reporteConcentradoFinalGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
    }
  },
  methods: {
    async reporteConcentradoFinalGrafica(
      masterId,
      embajadorId,
      sucursalId,
      gerenciaId,
      fechaInicio,
      fechaFinal,
      mostrarTodo
    ) {
      const params = {
        params: {
          masterId,
          embajadorId,
          sucursalId,
          gerenciaId,
          fechaInicio,
          fechaFinal,
          mostrarTodo
        }
      };
      try {
        const resp = await axios.get(concentradoFinal, params);
        let miGraficaConcentradoFinal = echarts.dispose(
          document.querySelector(".contenedor-grafica")
        );
        miGraficaConcentradoFinal = echarts.init(
          document.querySelector(".contenedor-grafica")
        );
        const reporteConcentradoData = resp.data.data;
        this.dataConcentrado = resp.data.data;
        const options = {
          color: ["#65451F", "#609966"],
          textStyle: {
            fontFamily: "Poppins"
          },
          legend: {
            show: true,
            top: "bottom",
            orient: "horizontal",
            left: "center",
            icon: "circle",
            textStyle: {
              color: "black"
            }
          },
          title: {
            text: "",
            left: "center",
            textStyle: {
              color: "black"
            }
          },
          tooltip: {
            trigger: "item"
          },
          xAxis: {
            type: "category",
            data: []
          },
          yAxis: {
            type: "value",
            show: false
          },
          series: [
            {
              name: "SUMA ESTATUS DIARIO",
              type: "bar",
              stillShowZeroSum: false,
              data: []
            },
            {
              name: "SUMA ACUMULADO POR PERIODO",
              type: "bar",
              stillShowZeroSum: false,
              data: []
            }
          ]
        };
        let validarExistenciaDatos = 0;
        let titulo = null;
        reporteConcentradoData.map((element, index) => {
          options.series[0].data.push({
            value: element.montoHoy,
            name: "Monto",
            label: labelFormatMontoOperaciones
          });
          options.series[1].data.push({
            value: element.montoFiltro,
            name: "Monto",
            label: labelFormatMontoOperaciones
          });
          options.xAxis.data.push(element.etapa);
          if(element.etapa === 'Prospecto') options.xAxis.data[index] = 'Prospecto Preautorizado'
          options.series[0].data[index].value > 0
            ? validarExistenciaDatos++
            : validarExistenciaDatos;
        });
        if (this.dataConcentrado.length > 0) {
          titulo = "Reporte concentrado final de operaciones";
          options.legend.show = true;
        } else {
          titulo = "NO HAY DATOS";
          options.legend.show = false;
        }
        options.title.text = titulo;
        miGraficaConcentradoFinal.setOption(options);
      } catch (error) {
        console.log(error);
      }
    }
  },
  computed: {
    isEmptyData() {
      return (
        this.dataConcentrado.length === 0
      );
    }
  }
};
</script>
<style scoped>
.contenedor-grafica {
  border: 2px solid #cbcbcb;
  padding: 20px;
  min-height: 500px;
  margin: 20px 0;
}
</style>
